<div class="card">
    <h1 class="title">IXH25 - Italian XRPL Hackathon</h1>
    <p class="subtitle">Rome, <strong>7-8 November 2025</strong>. Organized by XRPL Commons, University Blockchain
        Research Initiative (UBRI), and De Componendis Cifris.</p>
</div>

<section class="grid">
    <main>
        <div class="card">
            <h2>About IXH25</h2>
            <p>IXH25 is a national hackathon focused on cryptography and blockchain, with a strong emphasis on
                projects that integrate the XRP Ledger (XRPL). The event runs across two days with seminars,
                hands-on workshops, mentorship and a hackathon competition.
            </p>
            <h2>Registration</h2>
            <p class="meta">Tickets are limited. Sign up from <a href="https://luma.com/llwjrmcx">Luma</a>.</p>

            <h2 id="schedule" style="margin-top:18px">Schedule</h2>
            <p class="meta">(Timezome: Rome, CEST)</p>

            <table>
                <tr>
                    <td class="schedule-time">07 Nov <br> 11:00 - 12:00</td>
                    <td>Registration + APP demo <br> room M2</td>
                </tr>
                <tr>
                    <td class="schedule-time">07 Nov <br> 12:00 - 13:00</td>
                    <td> Welcome speeches and instructions: Roma Tre, XRPL Commons / UBRI, De Cifris <br> room M2</td>
                </tr>
                <tr>
                    <td class="schedule-time">07 Nov <br> 13:00 - 14:00</td>
                    <td>Lunch break and final team registration <br> corridor</td>
                </tr>
                <tr>
                    <td class="schedule-time">07 Nov <br> 14:00</td>
                    <td>Hackathon: coding starts <br> room M2 and room “informatica”</td>
                </tr>
                <tr>
                    <td class="schedule-time">08 Nov <br> 09:00 - 9:30</td>
                    <td>Hackathon: breakfast <br> corridor</td>
                </tr>
                <tr>
                    <td class="schedule-time">08 Nov <br> 12:00</td>
                    <td>Hackathon: project & pitch submission deadline</td>
                </tr>
                <tr>
                    <td class="schedule-time">08 Nov <br> 12:00 - 13:00</td>
                    <td>Hackathon: pitches <br> room M2 and room “informatica”</td>
                </tr>
                <tr>
                    <td class="schedule-time">08 Nov <br> 13:00 - 14:00</td>
                    <td>Lunch break <br> corridor</td>
                </tr>
                <tr>
                    <td class="schedule-time">08 Nov <br> 14:00 - 15:00</td>
                    <td>Demos & jury deliberation</td>
                </tr>
                <tr>
                    <td class="schedule-time">08 Nov <br> 15:00 - 15:30</td>
                    <td>Winners & awards ceremony</td>
                </tr>
                <tr>
                    <td class="schedule-time">08 Nov <br> 15:30 - 16:00</td>
                    <td>Celebration & closing catering</td>
                </tr>
                <tr>
                    <td class="schedule-time">08 Nov <br> 17:00</td>
                    <td>Hackathon ends & venue closes</td>
                </tr>
            </table>
        </div>
        <div class="card" style="margin-top:18px">
            <h2 style="margin-top:18px">Tracks & Challenges</h2>
            <p>Two official tracks: <strong>Advanced cryptography for blockchain</strong> and <strong>XRPL
                    applications</strong>. Exact challenges will be announced on-site.</p>

            <h2 style="margin-top:18px">Judging & Prizes</h2>
            <p class="meta">Judging criteria: Innovation, Execution, Impact, Pitch.</p>
            <p>Prize details: total prize pool of EUR 10,000.</p>

            <h2 style="margin-top:18px">Notes & Logistics</h2>
            <ul>
                <li>Teams: 3-8 people. Students who graduated in 2022-2025 are eligible for student categories.
                </li>
                <li>Funding & accommodation: support is available for student members.</li>
                <li>Mentors and technical support will be available during the hackathon.</li>
            </ul>
        </div>
        <div class="card" style="margin-top:18px">
            <h2 id="rules">Rules</h2>
            <div>
                <details>
                    <summary>
                        <b class="rule-name">1. Coding and projects</b>
                    </summary>
                    <ul>
                        <li><b>Coding starts</b> at 14:00 on November 7th and <b>submissions close</b> at 11:30 on
                            November
                            8th
                            (UTC+2).</li>
                        <li><b>New work only:</b> coding, development, and design should be done during the hackathon.
                            Any work
                            that
                            was completed prior to the hackathon must be mentioned in your submission. Non-team-created
                            software
                            or
                            intellectual property can be utilised if you have a licence
                            (e.g. software
                            libraries or design assets), but they must be mentioned in your submission.</li>
                        <li><b>Project pitches</b> will be of five minutes, followed by two minutes for questions. You
                            can
                            include
                            a
                            PowerPoint/PDF presentation. A live demo is also accepted (and encouraged).</li>
                        <li><b>Code versioning:</b> all submitted code must be in a version-controlled repository (e.g.,
                            GitHub)
                            and
                            made
                            accessible to judges at the time of submission.</li>
                    </ul>
                </details>
                <details>
                    <summary>
                        <b class="rule-name">2. Participants</b>
                    </summary>
                    <ul>
                        <li>
                            To be a <b>participant</b>, you need
                            <ol>
                                <li>to have legal rights to be in Rome during the event
                                    (e.g., if you
                                    are an EU
                                    citizen),</li>
                                <li>to be at least 18-year old on the 31-st of December 2025, and </li>
                                <li>to register on Luma.</li>
                            </ol>
                        </li>
                        <li>
                            We will not provide any documentation about your participation <b>before</b>
                            the event. An attendance certificate will be provided <b>after</b> the event.
                        </li>
                    </ul>
                </details>
                <details>
                    <summary>
                        <b class="rule-name">3. Students</b>
                    </summary>
                    <ul>
                        <li>To be considered a <b>student</b>
                            either be
                            enrolled as a BSC (<i>"laurea triennale"</i>), MSC (<i>"laurea magistrale"</i>), PHD
                            (<i>"dottorato"</i>) student or have
                            graduated as such in 2022, 2023, 2024 or 2025.</li>
                        <li>
                            This is a prerequisite to be part of an Italian University Team. Read more below at point 5.
                        </li>
                    </ul>
                </details>
                <details>
                    <summary>
                        <b class="rule-name">4. Teams</b>
                    </summary>
                    <ul>
                        <li>
                            Teams can consist of 3 to 8 participants. Participants may only be part of one team.</li>
                        <li>If a participant wants to register and be affiliated with a team, he/she must write to <a
                                href="mailto:hack@decifris.it">hack&#64;decifris.it</a> and
                            communicate the chosen team leader, no later than November 1st.</li>
                        <li>If a participant does not declare a team leader in time, he/she will become part of teams
                            formed by the
                            organizers at the beginning of the event.
                        </li>
                    </ul>
                </details>
                <details>
                    <summary>
                        <b class="rule-name">5. Italian University Teams (IUTs)</b>
                    </summary>
                    <ul>
                        <li>Italian universities may have one or more affiliated teams (IUTs).</li>
                        <li>IUTs team leaders must register to the hackathon, both in Luma and sending an email to
                            <a href="mailto:hack@decifris.it">hack&#64;decifris.it</a>,
                            no later than November 1st.
                        </li>
                        <li>IUTs team members must register to the hackathon, both in Luma and sending an email to
                            <a href="mailto:hack@decifris.it">hack&#64;decifris.it</a>,
                            no later than November 1st.
                        </li>
                        <li>To be part of an IUT, you must satisfy:
                            <ol>
                                <li>the requirements to be a participant</li>
                                <li>the requirements to be a student (of said University)</li>
                                <li>to be either a nonEU citizen or a EU citizen who is also a member of De Cifris (or
                                    that he/she
                                    has applied for
                                    membership)</li>
                            </ol>
                        </li>
                    </ul>
                </details>
                <details>
                    <summary>
                        <b class="rule-name">6. Tracks and projects</b>
                    </summary>
                    <ul>
                        <li>
                            The hackathon consists of two tracks, which correspond to two different challenges. Each
                            team
                            will select its own track during the event and submit only one project. <br>
                            Details on the challenges will be given during the event.
                        </li>
                        <li><b>Track 1: Advanced cryptography for blockchain</b>
                            <br>
                            Projects under this track must demonstrate a clear application of cryptographic techniques
                            to
                            solve the
                            challenge. The challenge can include, but is not limited to, encryption algorithms,
                            zero-knowledge
                            proofs,
                            digital signatures, or other privacy-enhancing technologies.
                        </li>
                        <li><b>Track 2: XRPL applications</b>
                            <br>
                            Projects under this track must involve the XRP Ledger in some way, whether
                            through integrations, apps, decentralised finance,
                            or smart contracts. Creativity and innovation in utilising the XRP ledger to solve the
                            challenge are
                            highly encouraged.
                        </li>
                    </ul>
                </details>
                <details>
                    <summary>
                        <b class="rule-name">7. Judging criteria</b>
                    </summary>
                    <ul>
                        <li><b>Innovation</b>: How original is the idea? Does it bring new insights or solutions?
                        </li>
                        <li><b>Execution</b>: How well was it developed? Does it demonstrate technical complexity or
                            impressive
                            engineering?</li>
                        <li><b>Impact</b>: How impactful is the project? Does it add value to a particular community,
                            scenario
                            or
                            industry?</li>
                        <li><b>Pitch</b>: Is the project clearly communicated? Is the demo (if present) well-prepared
                            and
                            convincing?</li>
                    </ul>
                </details>
                <details>
                    <summary>
                        <b class="rule-name">8. Prizes and awards</b>
                    </summary>
                    <ul>
                        <li>
                            Prizes will be awarded to the top 3 projects in each track:
                            <ol>
                                <li>1st winner: € 2500 (two thousands and five hundreds)</li>
                                <li>2nd winner: € 1500 (one thousand and five hundreds)</li>
                                <li>3rd winner: € 500 (five hundreds)</li>
                            </ol>
                        </li>
                    </ul>
                </details>
                <details>
                    <summary>
                        <b class="rule-name">9. Disqualification and misconduct</b>
                    </summary>

                    <ul>
                        <li>
                            Participants will be disqualified if they:
                        </li>
                        <ol>
                            <li>Fail to comply with intellectual property or copyright rules.</li>
                            <li>Submit projects containing offensive, discriminatory, or harmful content.</li>
                            <li>Exhibit any form of cheating, including tampering with other teams' projects.</li>
                        </ol>
                    </ul>
                </details>
                <details>
                    <summary>
                        <b class="rule-name">10. Miscellanea</b>
                    </summary>
                    <ul>
                        <li>
                            <b>Funding for eligible participants:</b>
                            if you are a student (as defined above at point 3) and <a href="/associazione/associarsi">a
                                DeCifris
                                member</a> (or
                            you are applying for membership), you are eligible for both a refund of your travel expenses
                            and free
                            accomodation for two/three nights (that we provide). Young membership only costs 5 euros. If
                            you think
                            that you are eligible, please contact us at <a
                                href="mailto:hack@decifris.it">hack&#64;decifris.it</a>
                            as soon as possible for confirmation (no later than November 15th) and the relevant
                            paperwork.
                        </li>
                        <li><b>Code of conduct:</b> All participants are expected to ensure a respectful environment.
                        </li>
                        <li><b>Venue:</b> The main venue is the rectorate of University of Roma Tre (via Ostiense 133,
                            Roma). The
                            complex closes between 21:00 (22nd) and 08:00 (23rd): you will be welcome to stay there
                            overnight, but
                            for
                            security reasons you will only be able to exit, not enter, before 08:00. </li>
                        <li><b>Support and Mentorship:</b> Mentors will be available to assist with technical or
                            project-related
                            queries.</li>
                        <li><b>FAQs:</b> additional questions may be asked before or during the event <span
                                class="highlight highlight-date"><i class="fa-brands fa-discord"></i> in our new De
                                Cifris
                                <a href="https://discord.gg/4nckwwWhuH" class="register-link">Discord
                                    server</a>
                            </span>, still under construction.</li>
                    </ul>
                </details>
            </div>
        </div>
    </main>

    <aside>
        <div class="card">
            <h2>Details</h2>
            <div><strong>Location:</strong> Largo S. Leonardo Murialdo, 1, 00146 Roma RM.</div>
            <div><strong>Format:</strong> Workshops, hackathon, pitches.</div>
            <div><strong>Who:</strong> Students, developers & enthusiasts.</div>
            <div><strong>When:</strong> November 7th-8th.</div>
            <a class="btn ghost" href="mailto:hack&#64;decifris.it">Contact: hack&#64;decifris.it</a>

            <h2>Organizers & Partners</h2>
            <div class="grid">
                <a href="https://www.decifris.it" target="_blank" class="image-wrapper-vertical">
                    <img src="../../../../assets/images/icons/decifris.svg" alt="Decifris logo">
                </a>
                <a href="https://www.xrpl-commons.org/" target="_blank" class="image-wrapper-vertical">
                    <img src="../../../../assets/images/logos/xrplcommons.webp" alt="XRPL Commons logo">
                </a>
                <a href="https://www.uniroma3.it/" target="_blank" class="image-wrapper-vertical">
                    <img src="../../../../assets/images/logos/roma3_new.png" alt="Roma Tre logo">
                </a>
                <a href="https://ripple.com/impact/ubri/" target="_blank" class="image-wrapper-vertical">
                    <img src="../../../../assets/images/logos/rippleimpact.png" alt="Ripple Impact logo">
                </a>
                <a href="https://www.unitn.it/" target="_blank" class="image-wrapper-vertical">
                    <img src="../../../../assets/images/logos/unitn.png" alt="Unitn logo">
                </a>
            </div>
        </div>
    </aside>
</section>
<section class="grid" id="winners">
 <div class="card">
    <h2 style="margin-bottom: 20px;">IXH25 Winners</h2>
    <p>We are pleased to announce the winning teams of the IXH25 Hackathon. This year's competition featured two distinct tracks.</p>

    <h3>Track 1 - Advanced Cryptography for Blockchain</h3>
    <p>In this track, participants were asked to design and implement a cryptographic protocol enabling the secure execution of the F1-AI racing game. The challenge required ensuring that neither players nor the server could access or manipulate the secret car parameters or the speed formula, while still allowing races to be run fairly. Teams could use any cryptographic primitive or blockchain technology to build a privacy-preserving, verifiable, and secure solution.</p>
    <p><a href="https://drive.google.com/file/d/1NkwMQN705u5xdYd7kk1a06ZXsT0FkGtH/view?usp=sharing" target="_blank">[track 1]</a></p>

    <h4>🥇 1st Place - Unitn3 - 2500€</h4>
    <p>Project: We (try to) play the racing game F1-AI &nbsp;<a href="https://drive.google.com/file/d/1zAnKcg4U77IxnHiJ00NIL9hIopZjE2B7/view?usp=sharing" target="_blank">[slides]</a><br>
    Team members: Lorenzo Siriu, Lorenzo Viganò, Lorenzo Francini, Gabriele Radici, Matteo Sangalli, Luca Novità and Leonardo Rufini</p>
    <details>
        <summary>Description:</summary>
        <p>This project presents a cryptographic protocol for F1-AI, a racing game in which each car is defined by ten hidden parameters (flags) and evaluated using a secret speed function. Neither the players nor the server should know the actual flag values, and yet the system must allow players to train their cars and fairly determine race outcomes.</p>
        <p>To achieve this, we used cryptographic features together with the decentral- ized, public blockchain XRPL.</p>
    </details>

    <h4>🥈 2nd Place - UniCas - 1500€</h4>
    <p>Project: F1-AI [πve] &nbsp;<a href="https://www.youtube.com/watch?v=CfjHgaJD_uc" target="_blank">[youtubevideo]</a><br>
    Team members: Emanuele Nardone, Rosa Fera, Emanuele Vita, Gabriele Lozupone and Sara Marchetti</p>
    <details>
        <summary>Description:</summary>
        <p>F1-AI is an innovative racing simulation system that leverages advanced cryptographic techniques to maintain complete privacy during computation. The system uses Fully Homomorphic Encryption (FHE) to enable Formula 1 race simulations where car characteristics and performance metrics remain encrypted throughout the entire computation process. Five independent judges collaboratively generate encrypted car data through distributed key generation, ensuring no single party can access sensitive information. The system computes car velocities using the quadratic form $S = t^T W t$ on encrypted data, then uses threshold decryption requiring all judges to reveal final race results. Cars can be "trained" through encrypted parameter updates to improve performance, all while maintaining cryptographic privacy guarantees.</p>
    </details>

    <h4>🥉 3rd Place - UniBa - 500€</h4>
    <p>Project: ZK_F1 Protocol &nbsp;<a href="https://drive.google.com/file/d/1T1iAwwwqtlCCLhKWlJWwSFMIr409tnGb/view?usp=sharing" target="_blank">[slides]</a><br>
    Team members: Luca Nestore, Giulia Verrigni, Giuseppe Scarfò, Mirra Carmine, Mohammed Rahmet Abdella and Abel Ataklti Belay</p>
    <details>
        <summary>Description:</summary>
        <p>Our project solves the core problem of trust and privacy online gaming using blockchain technology. The ZK-proofs guarantee that the player followed the rules and the contracts verifies it impartially. We're combining the NFTs (for ownership) ZK-Snarks (for private game logic) and Commit-Reveal (for race strategy).</p>
    </details>

    <h3>Track 2 - XRPL Applications</h3>

    <h4>🥇 1st Place - Epfl - 2500€</h4>
    <p>Project: PermiX &nbsp;<a href="https://drive.google.com/file/d/1OGvKh7sw1Vlod32UoRJogBPFxXjkKwBJ/view" target="_blank">[youtubevideo]</a><br>
    Team members: Stan Stelcher, Alexandre Mourot and Alexandre Huou</p>
    <details>
        <summary>Description:</summary>
        <p>PermiX solves the real problem blocking institutional DeFi adoption: compliance. Banks and financial institutions can't use permissionless DEXs because they violate regulations like MiCA, AML requirements, and age restrictions. PermiX lets institutions create controlled trading environments where only users with verified credentials can trade, with every verification and transaction recorded on-chain for regulators.</p>
    </details>

    <h4>🥈 2nd Place - XPRL Commons 2 - 1500€</h4>
    <p>Project: Agent Octopus &nbsp;<a href="https://www.youtube.com/watch?v=EmR_We0jAJg" target="_blank">[youtubevideo]</a><br>
    Team members: Krzysztof, Andrew Kaskaniotis, Divgun Singh and April Walker</p>
    <details>
        <summary>Description:</summary>
        <p>The future runs on energy, but the systems powering it are falling behind.</p>
        <p>As AI, automation, and data demands surge, global energy infrastructure built for the last century can't keep up. We're building a protocol that enables Energy Agents, autonomous AI systems, to discover, negotiate, and pay for energy in real time through XRPL.</p>
        <p>Today's energy networks are fragmented. Prices shift by the minute, settlements take days, and coordination between grids remains manual and inefficient. Our protocol allows intelligent agents to communicate directly, share data, and settle transactions instantly on-chain. This forms the foundation for a self-managing, intelligent energy network where AI systems, energy producers, and grids coordinate autonomously to make global energy smarter, faster, and more connected.</p>
    </details>

    <h4>🥉 3rd Place - ESCP Parigi - 500€</h4>
    <p>Project: XTrace &nbsp;<a href="https://drive.google.com/file/d/1qatjjxttUFJRQHGLPvtvoAOqYVKIbiiO/view?usp=share_link" target="_blank">[slides]</a><br>
    Team members: Samuel Kempf, Lennon Jeaugey and Daniel SK Tan</p>
    <details>
        <summary>Description:</summary>
        <p>XTrace is a complete compliance and safety suite for commercial banks and financial institutions issuing tokenized assets (like stablecoins or tokenized deposits) on the XRP Ledger.</p>
        <p>In an on-chain world where funds move 24/7, XTrace provides the tools to meet regulatory obligations (AML/KYC) and respond to fraud. It enables a seamless two-step workflow:</p>
        <ul>
            <li>Investigate: The XTrace Visualizer (a "bubble map") allows a compliance officer to trace the flow of funds in real-time. They can start with a central wallet and interactively follow the money trail by double-clicking nodes to "jump" to new accounts, instantly visualizing complex transaction networks.</li>
            <li>Act: Once a suspicious account is identified in the visualizer, the officer uses the Compliance Dashboard. They paste the account address to view its KYC status, balance, and freeze status. With a single click, they can take immediate on-chain action to Freeze the account (preventing fund movement) or Claw back illicit funds in cases of confirmed fraud or theft.</li>
        </ul>
        <p>This loop from investigation to action gives institutions the power to operate safely and confidently on-chain.</p>
    </details>

    <h4>🥉 3rd Place - UniTn1 - 500€</h4>
    <p>Project: Dungeon Ledger &nbsp;<a href="https://drive.google.com/file/d/1ETocWELhsEWfuJm--yS6SC93RphFhZNG/view?usp=sharing" target="_blank">[slides]</a><br>
    Team members: Michele Panariello, Leonardo Russo, Elena Bortolameotti, Mattia Donati, Jacqueline Koch, Jacopo Elefante and Fabio Rem Picci</p>
    <details>
        <summary>Description:</summary>
        <p>Dungeon Ledger is a roguelike adventure built on XRPL, where every hero and every piece of loot is a true digital asset you own. Battle through unpredictable dungeons, slay monsters, and upgrade your character using equipment you looted and now truly own, thanks to NFT based ownership. Designed with innovative features to enable feasible and sustainable play-to-earn without the need for any additional in-game token, Dungeon Ledger blends classic dungeon crawling gameplay with real rewards.</p>
    </details>
</div>
</section>